import { render, staticRenderFns } from "./auth_grant_list.vue?vue&type=template&id=2ed5abfd&scoped=true&"
import script from "./auth_grant_list.vue?vue&type=script&lang=js&"
export * from "./auth_grant_list.vue?vue&type=script&lang=js&"
import style0 from "./auth_grant_list.vue?vue&type=style&index=0&id=2ed5abfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5abfd",
  null
  
)

export default component.exports